var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTennisLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 522,
    viewBox: "0 0 522 522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M193.493 271.267c-.366 2.801-.767 5.67-1.206 8.581a349.224 349.224 0 0 1-2.9 16.638c-1.09 5.45-2.267 10.553-3.529 15.305l9.099-9.097 11.497-11.497m24.308 24.4l-11.876 11.877-8.657 8.657c4.746-1.26 9.842-2.436 15.284-3.525a363.085 363.085 0 0 1 16.645-2.892 444.14 444.14 0 0 1 10.31-1.432M290 340.647c-9.739.372-23.682 1.557-41.211 4.026-26.285 3.703-56.218 10.113-67.868 20.765L138.89 407.47l-22.997-25.72 41.107-41.103c10.57-11.74 16.644-41.25 20.331-67.416 2.476-17.537 3.226-34.484 3.591-44.231"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M30.801 513.844L8.157 491.2c-4.209-4.209-4.209-11.032 0-15.24l93.002-93.002c4.209-4.209 11.032-4.209 15.24 0l22.644 22.644c4.209 4.209 4.209 11.032 0 15.24l-93.002 93.002c-4.207 4.208-11.032 4.208-15.24 0zM181.22 181.22c-7.097 46.304 4.58 91.586 36.277 123.282 59.131 59.131 165.543 48.589 237.678-23.545 72.134-72.135 82.676-178.547 23.544-237.678C421.189-14.251 318.9-5.829 246.97 61.105m15.11 39.085a192.774 192.774 0 0 1 6.024-6.302c28.65-28.65 64.314-46.397 100.426-49.975 33.268-3.296 62.789 6.09 83.128 26.429s29.725 49.861 26.429 83.128c-3.577 36.112-21.326 71.776-49.975 100.426-28.649 28.649-64.314 46.397-100.426 49.975-33.268 3.296-62.789-6.09-83.128-26.429s-29.725-49.861-26.429-83.128c.752-7.59 2.13-15.16 4.103-22.649"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.25 293.847l198.189-198.19 5.027 9.115-192.773 192.773zM223.217 239.879L419.097 44l7.07 7.071-199.931 199.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.527 195.598L329 56.071 336.071 49l135.453 135.453zM364.922 295.993L233.434 164.505l7.095-7.047 131.464 131.464zM424.588 254.544l-160.01-160.01 7.072-7.07 160.009 160.009z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.794 159.33c-11.687 11.687-26.289 18.685-41.479 20.968a74.397 74.397 0 0 1-18.632.475c-16.525-1.65-32.594-8.798-45.237-21.443-12.652-12.652-19.8-28.72-21.452-45.246a74.341 74.341 0 0 1 .475-18.632c2.293-15.182 9.281-29.792 20.968-41.479 11.697-11.696 26.315-18.693 41.506-20.976a74.78 74.78 0 0 1 18.631-.475c16.509 1.65 32.576 8.798 45.228 21.451 12.644 12.644 19.79 28.712 21.452 45.228a74.694 74.694 0 0 1-.484 18.624c-2.283 15.19-9.28 29.81-20.976 41.505z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.08 110.851c-4.008.247-8.03.17-12.018-.231-16.525-1.65-32.594-8.798-45.238-21.443-12.652-12.652-19.8-28.721-21.451-45.246a74.239 74.239 0 0 1-.304-10.645M112.474 107.027c3.163-.085 6.329.03 9.479.342 16.508 1.65 32.576 8.798 45.228 21.451 12.644 12.644 19.79 28.712 21.451 45.228a75.11 75.11 0 0 1 .364 6.892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisLine);
export default __webpack_public_path__ + "static/media/tennis-line.48919276b867ddea338b47749866b6bf.svg";
export { ForwardRef as ReactComponent };